import React, { Fragment, useEffect, useState, useCallback } from 'react';
import { translate } from '../../Services/translation';
import getDistance from 'geolib/es/getDistance';
import {updatePreferedAddress} from '../../Actions/PreferedAddress.action'
import { useSelector,useDispatch } from 'react-redux';
import { distanceFormat } from "../../Services/Formatting.service";
import { googleAnalytics } from '../../Services/googleAnalytics';

const CloseDealerListDetailTags = (props) => {  
  const dispatch = useDispatch();  
  const [allAddresses, setAllAddresses] = useState(props);
  const selectedInfo = useSelector((state) => state.preferedAddress.selectedAddress);

  useEffect(() => {
    props.allreseller.map((address, index) => {
      address.distance=(getDistance(
        { latitude: props.lat, longitude: props.longt },
        { latitude: address.latitude, longitude: address.longitude}
      )/1000);
    });
   props.allreseller.sort((a, b) => a.distance - b.distance);
   setAllAddresses(props);
  });
  
  const getIcon=(assortment,rindex)=>{
    if (assortment == "boat_trailers") {
      return <Fragment><i key={'assortment'+rindex} className='icon-trailerboat'></i></Fragment>               
    }
    else if (assortment == "open_trailers") {
      return <Fragment><i key={'assortment'+rindex} className='cart__icon'></i></Fragment>
    }
    else if (assortment == "service") {
      return <Fragment><svg key={'assortment'+rindex}> <use href='/ui/images/sprites/brenderup.svg#service'></use></svg></Fragment>                
    }
    else if (assortment == "active" && props.isClickAndCollect == "True") {
      return <Fragment><svg><use href="/ui/images/sprites/brenderup.svg#fast-cart"></use></svg></Fragment>
    }
  }

  const sendDataLayer = (shopName, click) => {
    googleAnalytics({
      'event': 'dealerLocatorNearest', 
      'dealer': shopName,
      'click': click
    })
  }

  const addPreferedAddress = (event, address) => {
    if (event.target.checked == true) {
      dispatch(updatePreferedAddress(address));
    }
    else{
      dispatch(updatePreferedAddress(null));
    }
  }
 
  return (
    <Fragment>
      {props.allreseller&&
         props.allreseller.filter((a) =>a.distance <=150).map((address, index) => (
            // distance(props.lat,props.longt,address.latitude,address.longitude,'K',address,index)
            <li className="dealerlist__repeat" key={'CloseTab'+index}>
            <div className="row">
              <div className="columns small-12 dealerlist__basic">
                <div className="dealerlist__image">
                  <img src={address.partnericon} alt={address.partnerType} />
                </div>
                <div className="dealerlist__primary">
                  <div>
                  <span className="dealerlist__basic--name">{address.shopName}{' '}</span>
                  <span className="dealerlist__basic--km">{distanceFormat.format(address.distance)} Km</span>
                  </div>
                <div className="dealerlist__secondary">
                {address.streetName ? (
                        <span>{address.streetName}, </span>
                      ) : ''}
                    {address.zipCode ? (
                        <span>{address.zipCode}, </span>
                      ) : ''}
                      {address.city ? (
                        <span>{address.city} </span>
                      ) : ''}
                </div>
                </div>
                <div className="dealerlist__icons">
                  {address.productAssortment != null && address.productAssortment.map((assortment, index) => (                   
                      <Fragment>{getIcon(assortment, index)}</Fragment>                           
                  ))
                  }
                </div>
              </div>
              <div className="columns small-12">
                <details className="dealerlist__moreinfo">
                  <summary
                    className="open-text"
                    onClick={() => sendDataLayer(address.shopName, "Open-Dropdown")}
                  >
                    {translate('dealerlocator.contactinfo')}
                    <span className="close-text">{translate('dealerlocator.closecontactinfo')}</span>
                    <svg aria-hidden="true">
                      <use href="/ui/images/sprites/brenderup.svg#down-arrow"></use>
                    </svg>
                  </summary>

                  <ul className="dealerlist__contactinfo">
                    {address.telephone && (
                      <li onClick={() => sendDataLayer(address.shopName, "phone-number")}>
                        <svg aria-hidden="true">
                          <use href="/ui/images/sprites/brenderup.svg#phone" />
                        </svg>
                        <a href={`tel:${address.telephone}`}>{address.telephone}</a>
                      </li>
                    )}

                    {address.homePage && (
                      <li onClick={() => sendDataLayer(address.shopName, "home-page")}>
                        <svg aria-hidden="true">
                          <use href="/ui/images/sprites/brenderup.svg#desktop" />
                        </svg>
                        <a href={address.homePage} target="_blank" rel="noopener noreferrer">
                          {address.homePage}
                        </a>
                      </li>
                    )}

                    {address.email && (
                      <li onClick={() => sendDataLayer(address.shopName, "email")}>
                        <svg aria-hidden="true">
                          <use href="/ui/images/sprites/brenderup.svg#email" />
                        </svg>
                        <a href={`mailto:${address.email}`}>
                          {translate('dealerlocator.sendmessage')}
                        </a>
                      </li>
                    )}

                    {address.streetName && (
                      <li onClick={() => sendDataLayer(address.shopName, "map")}>
                        <svg aria-hidden="true">
                          <use href="/ui/images/sprites/brenderup.svg#street" />
                        </svg>
                        <a
                          href={`https://www.google.com/maps/?q=${address.latitude},${address.longitude}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {translate('dealerlocator.findhere')}
                        </a>
                      </li>
                    )}

                    <li
                      className="custom-checkbox"
                      onClick={() => sendDataLayer(address.shopName, "prefered")}
                    >
                      <input
                        id={`prefer-${address.addressId}`}
                        className="prefer-address"
                        type="checkbox"
                        checked={selectedInfo.addressId === address.addressId}
                        onChange={(event) =>
                          addPreferedAddress(event, address, index, props.markerId)
                        }
                      />
                      <label htmlFor={`prefer-${address.addressId}`}>
                        {translate('map.preferedretailer')}
                      </label>
                    </li>
                  </ul>
                </details>
              </div>
            </div>
          </li>
        ))}
    </Fragment>
  );
};

export default CloseDealerListDetailTags;